<template>
  <el-row type="flex" class="loginContainer" justify="center" align="middle">
    <vue-particles
          color="#ffffff"
          :particleOpacity="0.7"
          linesColor="#ffffff"
          :particlesNumber="80"
          shapeType="circle"
          :particleSize="5"
          :linesWidth="2"
          :lineLinked="true"
          :lineOpacity="0.4"
          :linesDistance="150"
          :moveSpeed="2"
          :hoverEffect="true"
          hoverMode="grab"
          :clickEffect="true"
          clickMode="push"
          class="particles-js">
    </vue-particles>
    <el-col :xs="20" :sm="18" :md="8" :lg="8" :xl="8">
      <div class="grid-content bg-purple">
        <div class="loginBlock">
          <img src="../assets/logo.png" width="100%">
          <el-button
            type="primary"
            icon="el-icon-caret-right"
            class="loginButton"
            @click="signInWithGoogle">
              Login in with Google
          </el-button>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import Firebase from 'firebase';

export default {
  name: 'Login',
  data() {
    return {
      loading: false,
      login: {
        email: '',
        password: '',
      },
    };
  },
  methods: {
    signInWithGoogle() {
      const provider = new Firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({ hd: 'harlemnext.com' });
      Firebase.auth().signInWithPopup(provider).then((result) => {
        this.user = result.user;

        const userEmail = this.user.email;
        const emailDomain = userEmail.substring(userEmail.lastIndexOf('@') + 1);
        const approvedDomains = ['harlemnext.com', 'connectstermedia.com', 'mediagiantnl.com', 'aclickconnectu.com', 'godai.nl']; // 'godai.nl', 'green8group.com', 'ratus.nl', 'mediagiantnl.com', 'connectstermedia.com', 'aclickconnectu.com'

        if (approvedDomains.includes(emailDomain)) {
          this.$router.replace('home');
          return false;
        }
        this.user.delete().then(() => {
          this.logOut();
        }).catch((error) => {
          console.log(error);
        });

        return false;
      }).catch(error => console.log(error));
    },
    logOut() {
      Firebase.auth().signOut().then(() => {
        this.user = '';
        this.$router.replace('/');
      }).catch((error) => {
        console.log(error);
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.loginBlock {
  text-align: center;
}

.loginContainer {
  height: 100%;
  background-color: #555;
}

.loginButton {
  position: relative;
  z-index: 1000;
}

.particles-js {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
}

</style>
